import {useContext} from 'preact/hooks';

import {BugsnagContext} from './context';

export const useBugsnag = () => useContext(BugsnagContext);
export const useBugsnagLeaveBreadcrumb = () =>
  useContext(BugsnagContext).leaveBreadcrumb;
export const useBugsnagNotify = () => useContext(BugsnagContext).notify;
